"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServusTVVideo1Schema = void 0;
exports.ServusTVVideo1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/servus-tv-video/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ServusTVVideo1",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:servus-tv-video:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "videoId": {
                    "type": "string",
                    "description": "Asset ID from MIT mediabase asset catalogue (e.g. AA-1UPS7JDND1W12)",
                    "pattern": "^([0-9]+-[0-9]+|AA-[A-Z0-9]{13}|AA[A-Z|0-9]{18})$"
                }
            },
            "required": [
                "videoId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9zZXJ2dXMtdHYtdmlkZW8vMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxvQkFBb0IsR0FBRztJQUNsQyxLQUFLLEVBQUUsb0ZBQW9GO0lBQzNGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLGdCQUFnQjtJQUN6QixNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sNENBQTRDO2FBQzdDO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixTQUFTLEVBQUU7b0JBQ1QsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxxRUFBcUU7b0JBQ3BGLFNBQVMsRUFBRSxtREFBbUQ7aUJBQy9EO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsU0FBUzthQUNWO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=